// const customizationReducer = (state = initialState, action) =>{

const themeReducer = (
    state = JSON.parse(localStorage.getItem('themeDark')),
    action
) => {
    switch (action.type) {
        case 'theme':
            return (state = JSON.parse(localStorage.getItem('themeDark')));
        default:
            return state;
    }
};

export default themeReducer;
